/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Locale} from '../models/Locale';

export interface GetUserLocale$Request {
    userId: number;
}

export interface GetUserLocale$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserLocaleRequest = createAction<PayloadData<void, GetUserLocale$Request>>('GET_USER_LOCALE__GET_USER_LOCALE__REQUEST');
export const getUserLocaleSuccess = createAction<PayloadData<Locale, GetUserLocale$Request>>('GET_USER_LOCALE__GET_USER_LOCALE__SUCCESS');
export const getUserLocaleFailure = createAction<PayloadData<Error, GetUserLocale$Request, true>>('GET_USER_LOCALE__GET_USER_LOCALE__FAILURE');

export const getUserLocaleActions = [
    getUserLocaleRequest,
    getUserLocaleSuccess,
    getUserLocaleFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserLocale = (meta: GetUserLocale$Request, config?: GetUserLocale$Config) => {
    return {
        CALL_API: {
            types: getUserLocaleActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/locale`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

